export const hasPersonData = (person) => Boolean(
  person?.identification?.trim()
  || person?.name?.trim()
  || person?.lastName?.trim(),
);

const normalizeBirthDate = (birthDate) => {
  if (!birthDate) {
    return undefined;
  }
  const date = new Date(birthDate);
  return new Date(date.setHours(0, 0, 0, 0)).toISOString();
};

const normalizePerson = (person) => {
  if (!person) {
    return undefined;
  }

  const normalized = { ...person };
  if (normalized.height != null && normalized.height !== '') {
    normalized.height = Number(normalized.height);
  }
  if (normalized.weight != null && normalized.weight !== '') {
    normalized.weight = Number(normalized.weight);
  }
  const birthDate = normalizeBirthDate(normalized.birthDate);
  if (birthDate) {
    normalized.birthDate = birthDate;
  }
  return normalized;
};

/**
 * Sanitiza el payload de insuranceApplication antes del POST.
 * InsuranceHolder solo se envía cuando withDifferentHolder es true (Infinity Kids).
 */
export default function mapIssuanceForApi(issuance, { withDifferentHolder = false } = {}) {
  const payload = { ...issuance };

  if (!withDifferentHolder || !hasPersonData(payload.insuranceHolder)) {
    delete payload.insuranceHolder;
  } else {
    payload.insuranceHolder = normalizePerson(payload.insuranceHolder);
  }

  if (payload.insuranceMainInsured) {
    payload.insuranceMainInsured = normalizePerson(payload.insuranceMainInsured);
  }

  return payload;
}

export function sanitizeQuotationRequest(requestData, { withDifferentHolder = false } = {}) {
  if (!requestData) {
    return requestData;
  }

  const sanitized = JSON.parse(JSON.stringify(requestData));
  if (!withDifferentHolder && sanitized.personalData?.insuranceHolder) {
    delete sanitized.personalData.insuranceHolder;
  }
  return sanitized;
}
